import React, { useState, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import { trackPromise } from "react-promise-tracker";

import {
  listarSellersOportunidade,
  listarVendedoresOportunidade,
  listarCdsOportunidadeSeller,
  cadastrarOportunidade,
  editarOportunidade,
  proximaOportunidade,
  buscarProdutoOportunidade,
  detalheOportunidade,
  duplicarOportunidade,
  buscarStatus,
  buscarStatusOferta,
  motivoDaOferta,
  listarTipoOportunidade,
  gerarPedidoEmPdf,
  cadastrarProduto,
  listaProdutoAtivo,
  excluirProduto,
  gerarConciliacao,
} from "../../../../services/http/oportunidadeService";
import { FaSearch, FaTimes } from "react-icons/fa";
import { useSnackBar } from "../../../../hooks/snackBar";

import {
  useFormik,
  getIn,
  FormikProvider,
  FieldArray,
  validateYupSchema,
  yupToFormErrors,
} from "formik";

import {
  formOportunidadeValidator,
  formOportunidadeInitialState,
  emptyDetalheLoteDto,
  emptylocalizacaoCarga,
  mapDataToSent,
} from "./editarOportunidadeValidator";

import FormControl from "@material-ui/core/FormControl";
import TextField from "@material-ui/core/TextField";
import FormHelperText from "@material-ui/core/FormHelperText";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Autocomplete from "@material-ui/lab/Autocomplete";
import "./styles.scss";

import { Button, Divider, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { NumberFormatCurrency } from "../../../../util/CurrencyFormat";
import { convertTextCurrencyToNumber } from "../../../../util/NumberConvert";
import dayjs from "dayjs";
import ButtonYesNo from "../../../../components/ButtonYesNo";
import { editarOportunidadeValidator } from "../../../PerfilSeller/Oportunidade/EditarOportunidade/editarSellerOportunidadeValidator";
import { formatarData } from "../../../../services/utils";
import globals from "../../../../globals";
import TableHeader from "../../../../components/Table/TableHeader";
import { Modal } from "@material-ui/core";
import { saveAs } from "file-saver";
import TablePagination from "../../../../components/Table/TablePagination";
import { buscarDadosProdutoSeller } from "../../../../services/http/SellerAdminstradorService/categoriaProdutoSellerService";

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: 48 * 4.5 + 8,
      width: 250,
    },
  },
  getContentAnchorEl: null,
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "center",
  },
  transformOrigin: {
    vertical: "top",
    horizontal: "center",
  },
  variant: "menu",
};

const LINK_PORTAL = globals.REACT_APP_URL_BASE_FRONT_PORTAL;

const EditarOportunidade = () => {
  const history = useHistory();
  const { id } = useParams();
  const { addSnackBar } = useSnackBar();
  const [vendedor, setVendedor] = useState("");
  const [ean, setEan] = useState("");
  const [sellers, setSellers] = useState([]);
  const [vendedores, setVendedores] = useState([]);
  const [cds, setCds] = useState([]);
  const [products, setProducts] = useState([]);
  const [listOfSellers, setListOfSellers] = useState([]);
  const [statusList, setStatusList] = useState([]);
  const [tipoList, setTipoList] = useState([]);
  const [statusOfertaList, setStatusOfertaList] = useState([]);
  const [motivoOfertaList, setMotivoOfertaList] = useState([]);
  const [validSeller, setValidSeller] = useState(false);
  const [validVenedor, setValidVendedor] = useState(true);
  const [abrirDetProduto, setAbrirDetProduto] = useState(false);
  const [statusDeal, setStatusDeal] = useState(1);
  const [statusOferta, setStatusOferta] = useState("");
  const [motivoOferta, setMotivoOferta] = useState("");
  const [novaListaProduto, setNovaListaProduto] = useState([]);
  const [novoProdutoSelecionado, setNovoProdutoSelecionado] = useState(null);
  const [tipoSelecionado, setTipoSelecionado] = useState("");
  const [codigo, setCodigo] = useState("");
  const [caixaPallet, setCaixaPallet] = useState("");
  const [novoDetalheProdutoSelecionado, setNovoDetalheProdutoSelecionado] =
    useState({});
  const [tipoOportunidade, setTipoOportunidade] = useState("");
  const [paginacao, setPaginacao] = useState({
    page: 1,
    pageSize: 10,
  });
  const [pedidoMinimoAlterado, setPedidoMinimoAlterado] = useState([
    { oportunidadeIndex: 0, status: false },
  ]);
  const [produtoQuantidadeAlterado, setProdutoQuantidadeAlterado] = useState([
    { oportunidadeIndex: 0, produtosStatus: [false] },
  ]);
  const [produtoEncontrado, setProdutoEncontrado] = useState(null);
  const [buscandoProduto, setBuscandoProduto] = useState(false);

  const formik = useFormik({
    initialValues: formOportunidadeInitialState(),
    validationSchema: formOportunidadeValidator(statusDeal),
    validateOnMount: false,
    validateOnChange: true,
    validateOnBlur: true,
    onSubmit: (values) => {
      if (!vendedor) {
        setValidVendedor(false);
      }
      // if (!abrirDetProduto) {
      //   submitOportunidade(values);
      // }
    },
  });

  const normalizeOpportunityPayload = (values) => {
    const payload = {
      ...values,
      motivoOfertaId:
        values?.motivoOferta ?? values?.motivoOfertaId ?? null,
      statusOfertaId:
        values?.statusOferta ?? values?.statusOfertaId ?? null,
      detalheLoteDto: values?.detalheLoteDto?.map((detalhe) => {
        if (!detalhe) return detalhe;

        return {
          ...detalhe,
          motivoOfertaId:
            detalhe?.motivoOferta ?? detalhe?.motivoOfertaId ?? null,
        };
      }),
    };

    delete payload.motivoOferta;
    delete payload.statusOferta;

    return payload;
  };
  const [initialValues, setInitialValues] = useState(
    formOportunidadeInitialState()
  );

  const handleDuplicateOpportunity = async () => {
    // const isValid = await formik.validateForm();
    // if (Object.keys(isValid).length !== 0) {
    //   addSnackBar({
    //     message: "Preencha todos os campos obrigatórios",
    //     info: "warning",
    //     open: true,
    //   });

    //   window.scrollTo({ top: 0, behavior: "smooth" });
    //   return;
    // }

    trackPromise(
      duplicarOportunidade(id).then((res) => {
        if (!res.fail) {
          addSnackBar({
            message: "Oportunidade duplicada com sucesso ",
            info: "success",
            open: true,
          });

          history.push("/oportunidade");

          return;
        }

        addSnackBar({
          message: "Erro ao duplicar oportunidade",
          info: "error",
          open: true,
        });
      })
    ).catch((error) => {
      console.log(error);
    });
  };
  const pegarProximaOportunidade = () => {
    trackPromise(
      proximaOportunidade().then((res) => {
        var novoValues = { ...formik.values };
        novoValues.codigo = res.data;

        setInitialValues(novoValues);
        formik.setValues(novoValues);
      })
    ).catch((error) => {
      console.log(error);
    });
  };
  const getNomeFantasiaSeller = () => {
    const response = sellers.find(
      (item) => item.dadosEmpresaSellerId === formik.values.dadosEmpresaSellerId
    );
    formik.setFieldValue("nomeFantasia", response?.nomeFantasia);
  };
  const listarStatus = () => {
    trackPromise(
      buscarStatus().then((res) => {
        if (!res.data) {
          addSnackBar({
            message: "Erro ao buscar listagem de status.",
            info: "warning",
            open: true,
          });
        }
        setStatusList(res.data);
      })
    ).catch(() => {
      setStatusList([]);
      addSnackBar({
        message: "Erro ao buscar listagem de status.",
        info: "warning",
        open: true,
      });
    });
  };
  const listarTipo = () => {
    trackPromise(
      listarTipoOportunidade().then((res) => {
        if (!res.data) {
          addSnackBar({
            message: "Erro ao buscar listagem de status.",
            info: "warning",
            open: true,
          });
        }
        setTipoList(res.data);
      })
    ).catch(() => {
      setTipoList([]);
      addSnackBar({
        message: "Erro ao buscar listagem de status.",
        info: "warning",
        open: true,
      });
    });
  };
  const listarStatusOferta = () => {
    trackPromise(
      buscarStatusOferta().then((res) => {
        if (!res.data) {
          addSnackBar({
            message: "Erro ao buscar listagem de status.",
            info: "warning",
            open: true,
          });
        }
        setStatusOfertaList(res.data);
      })
    ).catch(() => {
      setStatusOfertaList([]);
      addSnackBar({
        message: "Erro ao buscar listagem de status.",
        info: "warning",
        open: true,
      });
    });
  };
  const listarMotivoOferta = () => {
    trackPromise(
      motivoDaOferta().then((res) => {
        if (!res.data) {
          addSnackBar({
            message: "Erro ao buscar listagem de status.",
            info: "warning",
            open: true,
          });
        }
        setMotivoOfertaList(res.data);
      })
    ).catch(() => {
      setMotivoOfertaList([]);
      addSnackBar({
        message: "Erro ao buscar listagem de status.",
        info: "warning",
        open: true,
      });
    });
  };
  const listarSellers = () => {
    trackPromise(
      listarSellersOportunidade().then((res) => {
        if (!res.data) {
          addSnackBar({
            message:
              "É necessario cadastrar Seller para cadastrar oportunidade",
            info: "warning",
            open: true,
          });

          history.push("/oportunidade");
        }

        let array = [];
        res?.data?.forEach((element) => {
          array.push({
            label: `${element.cnpj} - ${element.nomeFantasia}`,
            id: element.dadosEmpresaSellerId,
          });
        });
        setListOfSellers(array);
        setSellers(res.data);
      })
    ).catch((error) => {
      console.log(error);
    });
  };
  const listarVendedores = (idEmpresa) => {
    trackPromise(
      listarVendedoresOportunidade(idEmpresa).then((res) => {
        if (!res.data) {
          addSnackBar({
            message:
              "É necessario ter usuário cadastrado para o Seller selecionado",
            info: "warning",
            open: true,
          });
        }
        setVendedores(res.data);
      })
    ).catch((error) => {
      console.log(error);
    });
  };
  const fnListarProdutosAtivos = (idEmpresa) => {
    var id = !!idEmpresa ? idEmpresa : formik.values.dadosEmpresaSellerId;
    trackPromise(
      listaProdutoAtivo(id, 1, 99999).then((res) => {
        const data = res.data
          ? res?.data?.lista?.map((item) => ({
              label: item.gtin + " " + item.nomeProduto,
              id: item.gtin,
            }))
          : [];

        setProducts(res?.data || []);
      })
    ).catch((error) => {
      console.log(error);
    });
  };

  useEffect(() => {
    if (formik.values.dadosEmpresaSellerId) {
      fnListarProdutosAtivos(formik.values.dadosEmpresaSellerId);
    }
  }, [formik.errors.dadosEmpresaSellerId]);
  const setarSeller = (_, value) => {
    if (value != null && value.id !== "selecione") {
      formik.setValues(initialValues);
      setValidSeller(true);
      setVendedor("");
      formik.setFieldValue("dadosEmpresaSellerId", value.id);
      formik.setFieldValue("userId", "");
      formik.setFieldValue("vendedor", "");
    } else {
      setValidSeller(false);
      setVendedor("");
      formik.setFieldValue("nomeFantasia", "");
      formik.setFieldValue("dadosEmpresaSellerId", "");
      formik.setFieldValue("userId", "");
      formik.setFieldValue("vendedor", "");
    }
  };
  const listarCds = (idEmpresa) => {
    trackPromise(
      listarCdsOportunidadeSeller(idEmpresa).then((res) => {
        if (!res.data) {
          addSnackBar({
            message: "É necessario ter CD cadastrado para o Seller selecionado",
            info: "warning",
            open: true,
          });
        }

        setCds(
          res.data.map((item) => ({
            id: item.id,
            cnpj: item.dadosCadastrais.cnpj,
            nomeFantasia: item.dadosCadastrais.nomeFantasia,
            cidade: item.dadosCadastrais.endereco.cidade,
            estado: item.dadosCadastrais.endereco.estado,
          }))
        );
      })
    ).catch((error) => {
      console.log(error);
    });
  };

  const fnSalvarOportunidadeNovo = () => {
    var obj = {
      id: id || null,
      dataAbertura: formik.values.dataAbertura || null,
      dataAtualizacao: formik.values.dataAtualizacao || null,
      // codigo: 0 || null,
      outro: formik.values.outro || null,
      statusDeal: formik.values.statusDeal || null,
      userId: formik.values.userId || null,
      // userCriacaoId: "string" || null,
      nomeCompleto: formik.values.nomeCompleto || null,
      dadosEmpresaSellerId: formik.values.dadosEmpresaSellerId || null,
      nomeFantasia: formik.values.nomeFantasia || null,
      nomeOportunidade: formik.values.nomeOportunidade || null,
      linkOportunidade: formik.values.linkOportunidade || null,
      motivoOfertaId: formik.values.motivoOferta || null,
      statusOfertaId: formik.values.statusOferta || null,
      tp: formik.values.tp || null,
      feeGreeners:
        formik.values.feeGreeners != "" ? Number(formik.values.feeGreeners) : 0,
      feeOperLog:
        formik.values.feeOperLog != "" ? Number(formik.values.feeOperLog) : 0,
      taxaST: formik.values.taxaST != "" ? Number(formik.values.taxaST) : 0,
      custoTotalSemST: formik.values.custoTotalSemST || null,
      substituicaoTributario: formik.values.substituicaoTributario || null,
      feeGreenersTotal:
        formik.values.feeGreenersTotal != ""
          ? Number(formik.values.feeGreenersTotal)
          : 0,
      feeOperLogTotal:
        formik.values.feeOperLogTotal != ""
          ? Number(formik.values.feeOperLogTotal)
          : 0,
      custoTotal: formik.values.custoTotal || null,
      tipoOportunidade: formik.values.tipoOportunidade || null,
      pedidoMinimo: formik.values.pedidoMinimo || null,
      detalheLoteDto: formik?.values.detalheLoteDto.slice(1)?.map((item) => ({
        ...item,
        lote: item.lote === "" ? " " : item.lote,
        motivoOfertaId:
          item?.motivoOferta ?? item?.motivoOfertaId ?? null,
      })),
    };

    const payload = normalizeOpportunityPayload(obj);
    trackPromise(
      cadastrarOportunidade(payload).then((res) => {
        if (res.fail) {
          const mensagemErro = res.errors[0]?.menssagem;
          addSnackBar({
            message: mensagemErro,
            info: "error",
            open: true,
          });

          return;
        }
        addSnackBar({
          message: "Cadastrado com sucesso",
          info: "success",
          open: true,
        });
        history.push(`/oportunidade/editar/${res.data}`);
      })
    ).catch((error) => {
      console.error("aa", error);
    });
  };
  const fnEditarOportunidade = () => {
    var obj = {
      id: id,
      dataAbertura: formik.values.dataAbertura,
      dataAtualizacao: formik.values.dataAtualizacao,
      codigo: formik.values.codigo,
      outro: formik.values.outro,
      statusDeal: formik.values.statusDeal,
      userId: formik.values.userId,
      // userCriacaoId: "string",
      nomeCompleto: formik.values.nomeCompleto,
      dadosEmpresaSellerId: formik.values.dadosEmpresaSellerId,
      nomeFantasia: formik.values.nomeFantasia,
      nomeOportunidade: formik.values.nomeOportunidade,
      linkOportunidade: formik.values.linkOportunidade,
      motivoOfertaId: formik.values.motivoOferta,
      statusOfertaId: formik.values.statusOferta,
      tp: formik.values.tp,
      feeGreeners:
        formik.values.feeGreeners != "" ? Number(formik.values.feeGreeners) : 0,
      feeOperLog:
        formik.values.feeOperLog != "" ? Number(formik.values.feeOperLog) : 0,
      taxaST: formik.values.taxaST != "" ? Number(formik.values.taxaST) : 0,
      custoTotalSemST: formik.values.custoTotalSemST,
      substituicaoTributario: formik.values.substituicaoTributario,
      feeGreenersTotal:
        formik.values.feeGreenersTotal != ""
          ? Number(formik.values.feeGreenersTotal)
          : 0,
      feeOperLogTotal:
        formik.values.feeOperLogTotal != ""
          ? Number(formik.values.feeOperLogTotal)
          : 0,
      custoTotal: formik.values.custoTotal,
      tipoOportunidade: formik.values.tipoOportunidade,
      pedidoMinimo: formik.values.pedidoMinimo,
      detalheLoteDto: formik?.values.detalheLoteDto?.map((item, index) => ({
        ...item,
        lote: item.lote === "" ? " " : item.lote,
        caixaPallet:
          Array.isArray(caixaPallet) && caixaPallet[index]
            ? caixaPallet[index].quantidadeDeCaixaPorPallet || ""
            : "",
        motivoOfertaId:
          item?.motivoOferta ?? item?.motivoOfertaId ?? null,
      })),
    };

    const payload = normalizeOpportunityPayload(obj);
  
    trackPromise(
      editarOportunidade(payload).then((res) => {
        if (res.fail) {
          const mensagemErro = res.errors[0]?.menssagem;
          addSnackBar({
            message: mensagemErro,
            info: "error",
            open: true,
          });

          return;
        }
        addSnackBar({
          message: "Editado com sucesso",
          info: "success",
          open: true,
        });
        buscarOportunidade(id);
      })
    ).catch((error) => {
      console.error("aa", error);
    });
  };
  const selecionarVendedor = (value) => {
    if (value) {
      setVendedor(value);
      formik.setFieldValue("vendedor", value);
    }
  };
  // async function buscarProdutos(produtos) {
  //   if (!formik.values.dadosEmpresaSellerId) {
  //     addSnackBar({
  //       message: "Selecione um Seller.",
  //       info: "error",
  //       open: true,
  //     });

  //     return;
  //   }

  //   if (produtos.some((a) => !a.gtinEan)) {
  //     addSnackBar({
  //       message: "Preencha o código de barras.",
  //       info: "error",
  //       open: true,
  //     });

  //     return;
  //   }

  //   var resultado = { ...formik.values };

  //   for (const produto of produtos) {
  //     const produtoResponse = await buscarProdutoOportunidade(
  //       resultado.dadosEmpresaSellerId,
  //       produto.gtinEan
  //     );

  //     if (!produtoResponse.data || produtoResponse.fail) return;

  //     console.log(produtoResponse.data.lote )
  //     resultado.detalheLoteDto[produto.indice] = {
  //       ...resultado.detalheLoteDto[produto.indice],
  //       statusDeal: resultado.statusDeal,
  //       statusOferta: resultado.statusOferta,
  //       dataAtualizacao: resultado.dataAtualizacao,
  //       gtinEan: produto.gtinEan,
  //       descricao:
  //         produtoResponse.data.descricao !== ""
  //           ? produtoResponse.data.descricao
  //           : "Não se aplica",
  //       categoria:
  //         produtoResponse.data.categoria !== ""
  //           ? produtoResponse.data.categoria
  //           : "Não se aplica",
  //       sku: produtoResponse.data.sku || "",
  //       descricaoLonga: produtoResponse.data.descricaoLonga || "Não se aplica",
  //       descricaoNcm: produtoResponse.data.descricaoNcm || "Não se aplica",
  //       precoMedio: produtoResponse.data.precoMedio,
  //       gpc: produtoResponse.data.gpc || "Não se aplica",
  //       marca: produtoResponse.data.marca || "Não se aplica",
  //       fabricante: produtoResponse.data.fabricante || "Não se aplica",
  //       urlImagens: produtoResponse.data.produtoUrlImagem,
  //       alturaUnidade: produtoResponse.data.alturaUnidade,
  //       profundidadeUnidade: produtoResponse.data.profundidadeUnidade,
  //       larguraUnidade: produtoResponse.data.larguraUnidade,
  //       quantidadeUnidade: produtoResponse.data.quantidadeUnidade,
  //       pesoBrutoUnidade: produtoResponse.data.pesoBrutoUnidade,
  //       pesoLiquidoUnidade: produtoResponse.data.pesoLiquidoUnidade,
  //       volumeUnidade: produtoResponse.data.volumeUnidade,
  //       larguraCaixa: produtoResponse.data.larguraCaixa,
  //       alturaCaixa: produtoResponse.data.alturaCaixa,
  //       volumeCaixa: produtoResponse.data.volumeCaixa,
  //       profundidadeCaixa: produtoResponse.data.profundidadeCaixa,
  //       pesoBrutoCaixa: produtoResponse.data.pesoBrutoCaixa,
  //       pesoLiquidoCaixa: produtoResponse.data.pesoLiquidoCaixa,
  //       alturaPallet: produtoResponse.data.alturaPallet,
  //       larguraPallet: produtoResponse.data.larguraPallet,
  //       profundidadePallet: produtoResponse.data.profundidadePallet,
  //       pesoBrutoPallet: produtoResponse.data.pesoBrutoPallet,
  //       pesoLiquidoPallet: produtoResponse.data.pesoLiquidoPallet,
  //       volumePallet: produtoResponse.data.volumePallet,
  //       quantidadePorCaixa: Number(produtoResponse.data.quantidadePorCaixa),
  //       validade: produtoResponse.data.validade,
  //       lote: produtoResponse.data.lote || "",
  //       descontoAplicado:
  //         resultado?.detalheLoteDto[produto.indice]?.descontoAplicado ||
  //         Number(produtoResponse.data.descontoAplicado),
  //       caixaPallet: Number(produtoResponse.data.quantidadeDeCaixaPorPallet),
  //       quantidadeDeCaixaPorPallet: Number(
  //         produtoResponse.data.quantidadeDeCaixaPorPallet
  //       ),
  //       gtinDun14Caixa: produtoResponse.data.gtinDun14Caixa,
  //       ncm: produtoResponse.data.ncm || "Não se aplica",
  //       descricaoNcm: produtoResponse.data.ncm || "Não se aplica",
  //       //dataValidade: res.data?.dataValidade,
  //       localizacaoCarga: resultado?.detalheLoteDto[produto.indice]
  //         ?.localizacaoCarga?.length
  //         ? resultado?.detalheLoteDto[produto.indice]?.localizacaoCarga
  //         : [emptylocalizacaoCarga],
  //     };
  //   }

  //   handleCalculateAutomaticFields(resultado);
  //   formik.setValues(resultado);
  // }
  // async function buscarProduto(gtinEan, indice) {
  //   await buscarProdutos([{ gtinEan, indice }]);
  // }
  const [selecionarProduto, setSelecionarProduto] = useState({
    disponiveis: [],
    selecionado: null,
    aba: "produtos",
  });

  const tabelaColunas = [
    "GTIN/EAN*",
    "SKU",
    "Descrição",
    "Lote",
    "Estoque (cx)*",
    "R$ por cx (s/ ST)*",
    "Dt. de validade*",
    "Taxa ST",
    "Unid. por cx",
    "R$ caixa (c/ ST)",
    "R$ caixa (c/ Fee)",
    "R$ unid. (s/ ST)",
    "R$ unid. (c/ ST)",
    "R$ unid (c/ Fee)",
    "Custo Total (R$)",
    "",
  ];

  // Estado de ordenação - inicia com EAN ASC (como a API retorna)
  const [sortConfig, setSortConfig] = useState({ columnIndex: 0, direction: 'asc' });

  // Colunas sortáveis: 0 = GTIN/EAN, 1 = SKU, 2 = Descrição
  const sortableColumns = [0, 1, 2];

  useEffect(() => {
    var novoSelecionarProduto = { ...selecionarProduto };

    if (formik.values.detalheLoteDto) {
      let erros = getIn(formik.errors, `detalheLoteDto`);
      if (!erros) {
        novoSelecionarProduto.disponiveis = formik.values.detalheLoteDto.map(
          (produto, indice) => ({
            indice,
            descricao: produto.oportunidadeId
              ? `#${indice + 1} - ${produto.gtinEan} | ${produto.descricao}` +
                (produto.dataValidade != null
                  ? ` | ${formatarData(produto.dataValidade, true)}`
                  : "")
              : `#${indice + 1}`,
            descricaoManter: produto.oportunidadeId
              ? `#${indice + 1} - ${produto.gtinEan} | ${produto.descricao}` +
                (produto.dataValidade != null
                  ? ` | ${formatarData(produto.dataValidade, true)}`
                  : "")
              : `#${indice + 1}`,
          })
        );

        if (novoSelecionarProduto.selecionado) {
          novoSelecionarProduto.selecionado =
            novoSelecionarProduto.disponiveis.find(
              (a) => a.indice === novoSelecionarProduto.selecionado.indice
            );
        }
      }
    } else {
      novoSelecionarProduto.disponiveis = [];
      novoSelecionarProduto.selecionado = null;
    }

    setSelecionarProduto(novoSelecionarProduto);
  }, [JSON.stringify(formik.values.detalheLoteDto)]);

  const handleCalculatePalletsAvailable = (lote) => {
    let result = 0;

    if (!lote.estoqueDisponivelCaixas || !lote.caixaPallet) {
      result = 0;
    } else {
      result = Math.ceil(
        Math.max(
          Number(lote.estoqueDisponivelCaixas) / Number(lote.caixaPallet),
          0
        )
      );
    }

    return result;
  };

  const handleCalculateUnitPrice = (lote) => {
    return Math.max(0, lote.precoVenda_NF_PorCaixa / lote?.quantidadePorCaixa);
  };

  const handleCalculatePriceOfSale = (lote) => {
    return Math.max(
      0,
      convertTextCurrencyToNumber(lote.valorSubstTributaria) +
        convertTextCurrencyToNumber(lote.precoVenda_NF_PorCaixa)
    );
  };

  const gerarRelatorioConciliacao = () => {
    trackPromise(
      gerarConciliacao(id).then((res) => {
        if (res.data) {
          saveAs(res.data, "relatorioConciliacao.xlsx");
        } else {
          addSnackBar({
            message: "Não foi possível extrair a base de conciliação",
            info: "warning",
            open: true,
          });
        }
      })
    ).catch((error) => {
      addSnackBar({
        message: "Erro ano extrair a base de conciliação",
        info: "error",
        open: true,
      });
    });
  };
  const [placeholderTipo, setPlaceholderTipo] = useState("");
  const handleCalculateUnitPriceFee = (lote) => {
    var campos = [lote.precoCaixa, lote.quantidadePorCaixa];

    for (var campo of campos) {
      if (campo === null || campo === undefined || campo === 0) return 0;
    }

    return Math.max(0, lote.precoCaixa / lote.quantidadePorCaixa);
  };

  const handleCalculateMarkup = (lote) => {
    var UnitPriceFee = handleCalculateUnitPriceFee(lote);
    if (
      UnitPriceFee === null ||
      UnitPriceFee === undefined ||
      UnitPriceFee === 0
    )
      return 0;

    return Number(
      Math.max(
        0,
        Number(lote.feeGreenersPrecoMedioVarejo) / UnitPriceFee - 1
      )?.toLocaleString("pt-br", { style: "currency", currency: "BRL" })
    );
  };

  const handleCalculateEconomy = (lote) => {
    return !!convertTextCurrencyToNumber(lote.feeGreenersPrecoMedioVarejo)
      ? Math.max(
          0,
          Number(lote.feeGreenersPrecoMedioVarejo) -
            handleCalculateUnitPriceFee(lote)
        )
      : 0;
  };

  const handleCalculateAutomaticFields = async (values) => {
    const listCDS = await listarCdsOportunidadeSeller(
      values.dadosEmpresaSellerId
    );

    (values?.detalheLoteDto || []).forEach((item, index) => {
      if (item.motivoOfertaList)
        item.motivoOfertaList = item.motivoOfertaList.trim();
      item.quantidadeTotalPallets = handleCalculatePalletsAvailable(item);
      item.precoUnidade1 = handleCalculateUnitPrice(item)?.toLocaleString(
        "pt-br",
        { style: "currency", currency: "BRL" }
      );
      item.precoVenda_NF_ST = handleCalculatePriceOfSale(item)?.toLocaleString(
        "pt-br",
        { style: "currency", currency: "BRL" }
      );
      item.precoUnitarioFee = handleCalculateUnitPriceFee(item)?.toLocaleString(
        "pt-br",
        { style: "currency", currency: "BRL" }
      );
      item.markup = handleCalculateMarkup(item) * 100;
      item.valorEconomia = handleCalculateEconomy(item)?.toLocaleString(
        "pt-br",
        { style: "currency", currency: "BRL" }
      );

      (item?.localizacaoCarga || []).forEach((location, locationIndex) => {
        const unidade = listCDS.data.find((cd) => cd.id === location.unidadeId);
        if (unidade) {
          location.cidade = unidade?.dadosCadastrais?.endereco?.cidade;
          location.estado = unidade?.dadosCadastrais?.endereco?.estado;
        }
      });
    });
  };

  const buscarOportunidade = (oportunidadeId) => {
    trackPromise(
      detalheOportunidade(oportunidadeId)?.then((res) => {
        if (res?.fail) {
          throw new Error(res?.errors);
        }
       
        listarCds(res?.data?.dadosEmpresaSellerId);
        setVendedor(res?.data?.dadosEmpresaSellerId);
        setTipoSelecionado(res?.data?.tipoOportunidade);
        setCodigo(res?.data?.codigo);
        setCaixaPallet(res?.data?.produtoOportunideResponseDto);
        const totalSKU =
          res?.data?.detalheLoteDto?.length > 0
            ? res?.data?.detalheLoteDto?.length
            : 1;

        const values = {
          ...res?.data,
          motivoOferta:
            res?.data?.motivoOferta ??
            res?.data?.motivoOfertaId ??
            "",
          statusOferta:
            res?.data?.statusOferta ??
            res?.data?.statusOfertaId ??
            "",
          totalSKU: totalSKU,
          detalheLoteDto:
            res?.data?.detalheLoteDto || res?.data?.detalheLoteDto,
        };

        values?.detalheLoteDto?.forEach((item, index) => {
          if (!item.localizacaoCarga || !item.localizacaoCarga.length) {
            values.detalheLoteDto[index]["localizacaoCarga"] = [
              emptylocalizacaoCarga,
            ];
          }

          values.detalheLoteDto[index].motivoOferta =
            item?.motivoOferta ??
            item?.motivoOfertaId ??
            "";
        });

        formik.resetForm({ values });
        setInitialValues(values);

        if (values?.userId) {
          setValidSeller(true);
        }

        formik.setErrors({});
        setStatusDeal(res?.data?.statusDeal);
        setStatusOferta(res?.data?.statusOferta || "");
        setMotivoOferta(res?.data?.motivoOferta || "");
      })
    ).catch((error) => {
      addSnackBar({
        message: "Não foi possível encontrar a oportunidade.",
        info: "error",
        open: true,
      });
      console.log(error);
    });
  };
  const fnExcluirProduto = (idProduto) => {
    if (id) {
      var obj = {
        oportunidadeId: id,
        produtoId: idProduto,
      };
      trackPromise(
        excluirProduto(obj).then((res) => {
          if (res.fail) {
            const mensagemErro = res.errors[0]?.menssagem;
            addSnackBar({
              message: mensagemErro,
              info: "error",
              open: true,
            });

            return;
          }
          buscarOportunidade(id);
        })
      ).catch((error) => {
        console.error("aa", error);
      });
    } else {
      formik.setValues({
        ...formik.values,
        detalheLoteDto: formik.values.detalheLoteDto.filter(
          (produto) => produto.id !== idProduto
        ),
      });
    }
  };
  const fnCadastrarProduto = () => {
    var obj = {
      gtin: novoProdutoSelecionado.gtin,
      sku: novoProdutoSelecionado.sku || null,
      idEmpresaSeller: formik.values.dadosEmpresaSellerId,
      oportunidadeId: id ? id : null,
    };
    trackPromise(
      cadastrarProduto(obj).then((res) => {
        if (res.fail) {
          const mensagemErro = res.errors[0]?.menssagem;
          addSnackBar({
            message: mensagemErro,
            info: "error",
            open: true,
          });

          return;
        }

        formik.setValues({
          ...formik.values,
          detalheLoteDto: [...formik.values.detalheLoteDto, res.data],
        });

        // Limpar os campos após adicionar o produto com sucesso
        setNovoProdutoSelecionado(null);
        setEan("");
        setProdutoEncontrado(null);
      })
    ).catch((error) => {
      console.error("aa", error);
    });
  };

  const getFormikErrorsOportunidade = (index, property) =>
    getIn(formik.errors, `detalheLoteDto[${index}].${property}`);

  useEffect(() => {
    listarSellers();
    listarStatus();
    listarStatusOferta();
    listarMotivoOferta();
    listarTipo();
    if (id) {
      buscarOportunidade(id);
    } else {
      pegarProximaOportunidade();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    if (formik.values.dadosEmpresaSellerId && sellers.length) {
      getNomeFantasiaSeller();
      listarVendedores(formik.values.dadosEmpresaSellerId);
      listarCds(formik.values.dadosEmpresaSellerId);
      fnListarProdutosAtivos(formik.values.dadosEmpresaSellerId);

      var produtos = formik.values.detalheLoteDto
        .filter((produto) => produto.gtinEan)
        .map((produto, indice) => ({
          gtinEan: produto.gtinEan,
          indice,
        }));

      // buscarProdutos(produtos);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.values.dadosEmpresaSellerId, sellers]);

  // Sincronizar valores dos dropdowns quando as listas são carregadas
  useEffect(() => {
    if (statusOfertaList.length > 0 && formik.values.statusOfertaDescricao && !formik.values.statusOferta) {
      const statusOfertaId = statusOfertaList.find(item => item.nome === formik.values.statusOfertaDescricao)?.id;
      if (statusOfertaId) {
        formik.setFieldValue("statusOferta", statusOfertaId);
        setStatusOferta(statusOfertaId);
      }
    }
  }, [statusOfertaList, formik.values.statusOfertaDescricao]);

  useEffect(() => {
    if (motivoOfertaList.length > 0 && formik.values.motivoOfertaDescricao && !formik.values.motivoOferta) {
      const motivoOfertaId = motivoOfertaList.find(item => item.nome === formik.values.motivoOfertaDescricao)?.id;
      if (motivoOfertaId) {
        formik.setFieldValue("motivoOferta", motivoOfertaId);
        setMotivoOferta(motivoOfertaId);
      }
    }
  }, [motivoOfertaList, formik.values.motivoOfertaDescricao]);

  // function abrirModalProduto(){
  //   setAbrirDetProduto(true)
  // }
  // const gerarPedidoPdf = () => {
  //   setValidVendedor(false);
  //   trackPromise(
  //     gerarPedidoEmPdf(id).then((res) => {
  //       history.push('/produto/pdf', { pdfData: res.data });
  //     })
  //   ).catch((error) => {
  //   });
  // };

  const gerarPedidoPdf = async () => {
    trackPromise(
      gerarPedidoEmPdf(id).then((res) => {
        history.push("/produto/pdf", {
          pdfData: res.data,
          codigo: formik?.values?.codigo,
          dataCriacao: formik.values.dataCriacao,
          seller: formik.values.dadosEmpresaSellerId
            ? {
                label: sellers.find(
                  (a) =>
                    a.dadosEmpresaSellerId ===
                    formik.values.dadosEmpresaSellerId
                )?.nomeFantasia,
                id: formik.values.dadosEmpresaSellerId,
              }
            : null,
          tp: formik.values.tp,
          custoTotal: formik.values.custoTotal,
        });
      })
    ).catch((error) => {
      console.log(error);
    });
  };
  function handleCloseModal() {
    setAbrirDetProduto(false);
  }
  const fnVisualizarProdutoDetalhe = (gtin) => {
    trackPromise(
      buscarDadosProdutoSeller(gtin, formik.values.dadosEmpresaSellerId)
        .then((res) => {
          if (res.data) {
            setNovoDetalheProdutoSelecionado(res.data);
          } else {
            setAbrirDetProduto(false);
            addSnackBar({
              message: "Nenhum produto encontrado com o Gtin informado.",
              info: "warning",
              open: true,
            });
          }
        })
        .catch((error) => {
          setAbrirDetProduto(false);
          addSnackBar({
            message: "Erro ao tentar obter detalhes do produto por Gtin",
            info: "error",
            open: true,
          });
        })
    );
  };

  useEffect(() => {
    if (abrirDetProduto) {
      fnVisualizarProdutoDetalhe(
        novoProdutoSelecionado.gtin || novoProdutoSelecionado.gtinEan
      );
    }
  }, [abrirDetProduto]);
  useEffect(() => {
    if (
      formik.values.tipoOportunidade !== tipoSelecionado ||
      formik.values.tipoOportunidade === 1
    ) {
      formik.setValues({
        ...formik.values,
        pedidoMinimo: "",
      });
    }
    console.log(tipoSelecionado);
  }, [formik.values.tipoOportunidade]);

  useEffect(() => {
    if (ean && ean.trim() !== "" && products && products.length > 0) {
      setBuscandoProduto(true);

      // Simula um pequeno delay para mostrar o loading
      setTimeout(() => {
        // Busca por GTIN (que é o mesmo que EAN)
        const produto = products.find(
          (item) => item.gtin === ean || item.ean === ean
        );

        if (produto) {
          setNovoProdutoSelecionado(produto);
          // setProdutoEncontrado({
          //   success: true,
          //   message: `Produto encontrado: ${produto.nomeProduto}`,
          //   produto: produto
          // });
        } else {
          // Se não encontrar, limpa a seleção
          setNovoProdutoSelecionado(null);
          setProdutoEncontrado({
            success: false,
            message: "Produto não encontrado com este EAN/GTIN",
            produto: null,
          });
        }
        setBuscandoProduto(false);
      }, 300);
    } else if (!ean || ean.trim() === "") {
      // Se o EAN estiver vazio, limpa a seleção
      setNovoProdutoSelecionado(null);
      setProdutoEncontrado(null);
      setBuscandoProduto(false);
    }
  }, [ean, products]);

  // Função para ordenar produtos
  const handleSort = (columnIndex) => {
    let direction = 'asc';
    if (sortConfig?.columnIndex === columnIndex && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ columnIndex, direction });
  };

  // Função para obter produtos ordenados
  const getSortedProducts = () => {
    if (!formik?.values?.detalheLoteDto || !sortConfig) {
      return formik?.values?.detalheLoteDto || [];
    }

    const sorted = [...formik.values.detalheLoteDto].sort((a, b) => {
      let valueA, valueB;

      switch (sortConfig.columnIndex) {
        case 0: // GTIN/EAN
          valueA = (a.gtinEan || '').toLowerCase();
          valueB = (b.gtinEan || '').toLowerCase();
          break;
        case 1: // SKU
          valueA = (a.sku || '').toLowerCase();
          valueB = (b.sku || '').toLowerCase();
          break;
        case 2: // Descrição
          valueA = (a.descricao || '').toLowerCase();
          valueB = (b.descricao || '').toLowerCase();
          break;
        default:
          return 0;
      }

      if (valueA < valueB) {
        return sortConfig.direction === 'asc' ? -1 : 1;
      }
      if (valueA > valueB) {
        return sortConfig.direction === 'asc' ? 1 : -1;
      }
      return 0;
    });

    return sorted;
  };

  return (
    <form onSubmit={formik.handleSubmit}>
      <div className="row mt20 mb30">
        <div className="col-md-12 titulo">Oportunidades</div>
        <div className="col-md-12 font-thin">
          <strong>Detalhe da oportunidade</strong>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-2 col-md-2 col-lg-2">
          ID da Oportunidade <br />
          <strong>
            {formik?.values?.codigo?.toString()?.padStart(6, "0")}
          </strong>
        </div>
        <div className="col-sm-2 col-md-2 col-lg-2">
          Data de Criação <br />
          <strong>
            {dayjs(formik.values.dataAbertura).format("DD/MM/YYYY")}
          </strong>
        </div>
        {formik.values.dataAtualizacao && (
          <div className="col-sm-2 col-md-2 col-lg-2">
            Data última alteração <br />
            <strong>
              {formik.values.dataAtualizacao
                ? dayjs(formik.values.dataAtualizacao).format("DD/MM/YYYY")
                : ""}
            </strong>
          </div>
        )}
        <div className="col-sm-3 col-md-3 col-lg-3">
          <FormControl>
            <InputLabel id="demo-simple-select-helper-label">
              Status da Oportunidade *
            </InputLabel>
            <Select
              key={formik.values.statusDeal}
              className="select"
              variant="outlined"
              label="Status Deal *"
              id="statusDeal"
              MenuProps={MenuProps}
              value={formik.values.statusDeal}
              onChange={(e) => {
                formik.setFieldValue("statusDeal", e.target.value);
                setStatusDeal(e.target.value);
              }}
              error={Boolean(formik.errors.statusDeal)}
              helperText={formik.errors.statusDeal}
            >
              <MenuItem disabled={true} value="">
                <em>Selecione</em>
              </MenuItem>
              {statusList.map((item) => (
                <MenuItem key={item.id} value={item.id}>
                  {item.nome}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
      </div>
      <div className="row mt30 mb20">
        <div className="col-md-12 body">
          <strong>Dados do Seller</strong>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-2 col-md-2 col-lg-2">
          <FormControl key={formik.values.dadosEmpresaSellerId}>
            <Autocomplete
              className="select w100p"
              options={listOfSellers}
              onChange={setarSeller}
              name="dadosEmpresaSellerId"
              id="dadosEmpresaSellerId"
              noOptionsText="Sem Opções"
              getOptionLabel={(option) => option.label || "Selecione"}
              getOptionSelected={(option, value) =>
                option && value && option.id === value.id
              }
              value={
                formik.values.dadosEmpresaSellerId &&
                formik.values.dadosEmpresaSellerId !== "" &&
                sellers.length > 0
                  ? {
                      label:
                        (sellers && sellers.length > 0
                          ? sellers.find(
                              (a) =>
                                a.dadosEmpresaSellerId ===
                                formik.values.dadosEmpresaSellerId
                            )?.nomeFantasia
                          : "") || "",
                      id: formik.values.dadosEmpresaSellerId,
                    }
                  : null
              }
              renderInput={(params) => {
                return (
                  <TextField
                    {...params}
                    type="text"
                    className="solid"
                    error={formik.errors.dadosEmpresaSellerId}
                    variant="outlined"
                    label="Seller*"
                  />
                );
              }}
            />
            {formik.errors.dadosEmpresaSellerId && (
              <FormHelperText>Campo obrigatório</FormHelperText>
            )}
          </FormControl>
        </div>
      </div>
      <div className="row mt30 mb20">
        <div className="col-md-12 body">
          <strong>Detalhes da Oportunidade</strong>
        </div>
      </div>
      <div className="row">
        <div className="col-md-4">
          <FormControl>
            <TextField
              label="TP*"
              type="text"
              size="small"
              id="nomeOportunidade"
              name="nomeOportunidade"
              variant="outlined"
              value={formik.values.tp}
              onChange={(e) => {
                formik.setFieldValue("tp", e.target.value);
              }}
            />
          </FormControl>
        </div>
        <div className="col-sm-3 col-md-3 col-lg-3">
          <FormControl>
            <InputLabel id="demo-simple-select-helper-label">
              Motivo da Oferta*
            </InputLabel>
            <Select
              key={formik.values.motivoOferta}
              className="select"
              variant="outlined"
              label="Motivo da Oferta*"
              id="motivoOferta"
              MenuProps={MenuProps}
              value={formik.values.motivoOferta}
              onChange={(e) => {
                formik.setFieldValue("motivoOferta", e.target.value);
                setMotivoOferta(e.target.value);
              }}
              error={Boolean(formik.errors.motivoOferta)}
              helperText={formik.errors.motivoOferta}
            >
              <MenuItem disabled={true} value="">
                <em>Selecione</em>
              </MenuItem>
              {motivoOfertaList.map((item) => (
                <MenuItem key={item.id} value={item.id}>
                  {item.nome}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
        <div className="col-sm-3 col-md-3 col-lg-3">
          <FormControl>
            <InputLabel id="demo-simple-select-helper-label">
              Status da Oferta*
            </InputLabel>
            <Select
              key={formik.values.statusOferta}
              className="select"
              variant="outlined"
              label="Status da Oferta*"
              id="statusOferta"
              MenuProps={MenuProps}
              value={formik.values.statusOferta}
              onChange={(e) => {
                formik.setFieldValue("statusOferta", e.target.value);
                setStatusOferta(e.target.value);
              }}
              error={Boolean(formik.errors.statusOferta)}
              helperText={formik.errors.statusOferta}
            >
              <MenuItem disabled={true} value="">
                <em>Selecione</em>
              </MenuItem>
              {statusOfertaList.map((item) => (
                <MenuItem key={item.id} value={item.id}>
                  {item.nome}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
        <div className="col-sm-2 col-md-2 col-lg-2">
          <FormControl>
            <TextField
              label="Fee Greeners (%)"
              type="number"
              size="small"
              id="feeGreeners"
              name="feeGreeners"
              variant="outlined"
              value={formik.values.feeGreeners}
              onChange={formik.handleChange}
            />
          </FormControl>
        </div>

        {/* <div className="col-md-4">
          <FormControl>
            <TextField
              label="#SKUs nessa Oportunidade"
              type="number"
              InputProps={{ inputProps: { min: 1, defaultValue: 1 } }}
              size="small"
              id="totalSKU"
              name="totalSKU"
              variant="outlined"
              value={formik.values.totalSKU}
              onChange={(e) => {
                formik.handleChange(e);
                handleChangeTotalSKU(Number(e.currentTarget.value));
              }}
            />
          </FormControl>
        </div> */}
      </div>
      <div className="row">
        <div className="col-sm-2 col-md-2 col-lg-2">
          <FormControl>
            <TextField
              label="Fee Oper Log (%)"
              type="number"
              size="small"
              id="feeOperLog"
              name="feeOperLog"
              variant="outlined"
              value={formik.values.feeOperLog}
              onChange={formik.handleChange}
            />
          </FormControl>
        </div>
        <div className="col-sm-2 col-md-2 col-lg-2">
          <FormControl>
            <TextField
              label="Taxa ST (Oportunidade)"
              type="number"
              size="small"
              id="taxaST"
              name="taxaST"
              variant="outlined"
              value={formik.values.taxaST}
              onChange={formik.handleChange}
            />
          </FormControl>
        </div>
        {/* <div className="col-md-4">
          <FormControl>
            <TextField
              label="#SKUs nessa Oportunidade"
              type="number"
              InputProps={{ inputProps: { min: 1, defaultValue: 1 } }}
              size="small"
              id="totalSKU"
              name="totalSKU"
              variant="outlined"
              value={formik.values.totalSKU}
              onChange={(e) => {
                formik.handleChange(e);
                handleChangeTotalSKU(Number(e.currentTarget.value));
              }}
            />
          </FormControl>
        </div> */}
      </div>
      {/* <div className="row">
        <div className="col-md-8">
          <FormControl>
            <TextField
              label="Nome da Oportunidade"
              type="text"
              size="small"
              id="nomeOportunidade"
              name="nomeOportunidade"
              variant="outlined"
              value={formik.values.nomeOportunidade}
              onChange={formik.handleChange}
            />
          </FormControl>
        </div>
        <div className="col-md-4">
          <FormControl>
            <TextField
              label="#SKUs nessa Oportunidade"
              type="number"
              InputProps={{ inputProps: { min: 1, defaultValue: 1 } }}
              size="small"
              id="totalSKU"
              name="totalSKU"
              variant="outlined"
              value={formik.values.totalSKU}
              onChange={(e) => {
                formik.handleChange(e);
                handleChangeTotalSKU(Number(e.currentTarget.value));
              }}
            />
          </FormControl>
        </div>
      </div> */}
      <div className="row">
        <div className="col-12 mt20">
          <div style={{ overflowX: "auto" }}>
            {formik?.values.detalheLoteDto.length > 0 ? (
              <table className="table">
                <TableHeader
                  columns={tabelaColunas}
                  onSort={handleSort}
                  sortConfig={sortConfig}
                  sortableColumns={sortableColumns}
                />

                <tbody>
                  {(!selecionarProduto.disponiveis ||
                    selecionarProduto.disponiveis?.length === 0) && (
                    <tr>
                      <td colSpan="7"> Sem Registros </td>
                    </tr>
                  )}

                  {getSortedProducts()?.map(
                    (data, i) =>
                      data.id && (
                        <tr key={data.id}>
                          <td> {data.gtinEan} </td>
                          <td> {data.sku || "N/A"} </td>
                          <td style={{ minWidth: "400px" }}>
                            {" "}
                            {data.descricao}{" "}
                          </td>

                          <td>
                            <TextField
                              label=""
                              type="text"
                              size="small"
                              style={{ minWidth: "150px" }}
                              id="lote"
                              name="lote"
                              variant="outlined"
                              value={data.lote}
                              onChange={(e) => {
                                formik.setFieldValue(
                                  `detalheLoteDto.${i}.lote`,
                                  e.target.value
                                );
                              }}
                            />
                          </td>

                          <td>
                            <TextField
                              label=""
                              type="number"
                              InputProps={{ inputProps: { min: 0 } }}
                              style={{ minWidth: "150px" }}
                              size="small"
                              id="estoqueDisponivelCaixas"
                              name="estoqueDisponivelCaixas"
                              variant="outlined"
                              value={data.estoqueDisponivelCaixas || ""}
                              onChange={(e) => {
                                formik.setFieldValue(
                                  `detalheLoteDto.${i}.estoqueDisponivelCaixas`,
                                  Number(e.target.value)
                                );
                              }}
                            />
                          </td>
                          <td>
                            <TextField
                              label=""
                              type="text"
                              style={{ minWidth: "150px" }}
                              size="small"
                              id="precoCaixa"
                              name="precoCaixa"
                              variant="outlined"
                              value={
                                data.precoCaixa
                                  ? data.precoCaixa.toLocaleString("pt-br", {
                                      style: "currency",
                                      currency: "BRL",
                                    })
                                  : "R$ 0,00"
                              }
                              onChange={(e) => {
                                const value = e.target.value.replace(/\D/g, "");
                                formik.setFieldValue(
                                  `detalheLoteDto.${i}.precoCaixa`,
                                  value ? Number(value) / 100 : 0
                                );
                              }}
                              inputProps={{
                                onKeyDown: (e) => {
                                  if (e.key === "Enter") {
                                    e.preventDefault();
                                  }
                                },
                                onChange: (e) => {
                                  e.target.value = e.target.value.replace(
                                    /\D/g,
                                    ""
                                  );
                                  e.target.value = (
                                    Number(e.target.value) / 100
                                  ).toLocaleString("pt-br", {
                                    style: "currency",
                                    currency: "BRL",
                                  });
                                },
                              }}
                            />
                          </td>

                          <td>
                            <TextField
                              label=""
                              type="date"
                              size="small"
                              id="dataValidade"
                              name="dataValidade"
                              variant="outlined"
                              value={
                                data.dataValidade
                                  ? data.dataValidade.substring(0, 10)
                                  : ""
                              }
                              onChange={(e) => {
                                formik.setFieldValue(
                                  `detalheLoteDto.${i}.dataValidade`,
                                  e.target.value
                                    ? e.target.value.substring(0, 10)
                                    : ""
                                );
                              }}
                            />
                          </td>

                          <td>
                            {formik.values.taxaST ? (
                              data.taxaST
                            ) : (
                              <TextField
                                label=""
                                type="number"
                                size="small"
                                id="taxaST"
                                style={{ minWidth: "150px" }}
                                name="taxaST"
                                variant="outlined"
                                value={data.taxaST}
                                onChange={(e) => {
                                  formik.setFieldValue(
                                    `detalheLoteDto.${i}.taxaST`,
                                    Number(e.target.value)
                                  );
                                }}
                              />
                            )}
                          </td>
                          <td> {data.quantidadePorCaixa} </td>
                          <td>
                            {" "}
                            {data.valorCaixaComST?.toLocaleString("pt-br", {
                              style: "currency",
                              currency: "BRL",
                            })}{" "}
                          </td>
                          <td>
                            {" "}
                            {data.valorCaixaComFee?.toLocaleString("pt-br", {
                              style: "currency",
                              currency: "BRL",
                            })}{" "}
                          </td>
                          <td>
                            {" "}
                            {data.valorUnidadeSemST?.toLocaleString("pt-br", {
                              style: "currency",
                              currency: "BRL",
                            })}{" "}
                          </td>
                          <td>
                            {" "}
                            {data.valorUnidadeComST?.toLocaleString("pt-br", {
                              style: "currency",
                              currency: "BRL",
                            })}{" "}
                          </td>
                          <td>
                            {" "}
                            {data.valorUnidadeComFee?.toLocaleString("pt-br", {
                              style: "currency",
                              currency: "BRL",
                            })}{" "}
                          </td>
                          <td>
                            {" "}
                            {data.totalCusto?.toLocaleString("pt-br", {
                              style: "currency",
                              currency: "BRL",
                            })}{" "}
                          </td>
                          <td>
                            <div key="icons" className="d-flex">
                              <FaSearch
                                onClick={() => {
                                  setAbrirDetProduto(true);
                                  setNovoProdutoSelecionado(data);
                                }}
                                style={{
                                  color: "black",
                                  cursor: "pointer",
                                  marginRight: "8px",
                                }}
                              />

                              <FaTimes
                                onClick={() => {
                                  fnExcluirProduto(data.id);
                                }}
                                style={{ color: "red", cursor: "pointer" }}
                              />
                            </div>
                          </td>
                          <td className="text-right">
                            <div className="row"></div>
                          </td>
                        </tr>
                      )
                  )}
                </tbody>
              </table>
            ) : (
              <h2 className="text-center border w-100 py-3">
                Produtos não cadastrados para essa Oportunidade
              </h2>
            )}
          </div>
        </div>
      </div>
      <TablePagination
        data={products}
        changePage={(e) => {
          setPaginacao((prev) => ({ ...prev, page: e }));
        }}
      />
      <div className="row">
        <div className="col-3">
          <FormControl>
            <TextField
              label="EAN"
              type="text"
              size="small"
              id="ean"
              name="ean"
              variant="outlined"
              value={ean}
              onChange={(e) => {
                setEan(e.target.value);
              }}
              onKeyPress={(e) => {
                if (e.key === "Enter" && novoProdutoSelecionado) {
                  e.preventDefault();
                  // Foca no próximo campo ou executa alguma ação
                  document.getElementById("produto-autocomplete")?.focus();
                }
              }}
              InputProps={{
                endAdornment: buscandoProduto ? (
                  <div style={{ color: "#666", fontSize: "14px" }}>🔍</div>
                ) : null,
              }}
            />
            {produtoEncontrado && (
              <div
                style={{
                  marginTop: "5px",
                  fontSize: "12px",
                  color: produtoEncontrado.success ? "#4caf50" : "#f44336",
                  fontWeight: "500",
                }}
              >
                {produtoEncontrado.message}
                {produtoEncontrado.success && produtoEncontrado.produto && (
                  <div
                    style={{
                      marginTop: "8px",
                      padding: "8px",
                      backgroundColor: "#f5f5f5",
                      borderRadius: "4px",
                      fontSize: "11px",
                    }}
                  >
                    <div>
                      <strong>SKU:</strong> {produtoEncontrado.produto.sku}
                    </div>
                    <div>
                      <strong>GTIN:</strong> {produtoEncontrado.produto.gtin}
                    </div>
                    <div style={{ marginTop: "4px", fontStyle: "italic" }}>
                      {produtoEncontrado.produto.descricaoCompleta}
                    </div>
                  </div>
                )}
              </div>
            )}
          </FormControl>
        </div>
        <div className="col-3">
          <FormControl fullWidth>
            <Autocomplete
              id="produto-autocomplete"
              className="select w100p"
              options={products || []}
              getOptionLabel={(option) => option?.nomeProduto || ""}
              value={novoProdutoSelecionado}
              disabled={ean && novoProdutoSelecionado}
              onChange={(event, newValue) => {
                setNovoProdutoSelecionado(newValue);
                // Se um produto for selecionado manualmente, limpa o campo EAN
                if (newValue) {
                  setEan("");
                  setProdutoEncontrado(null);
                }
              }}
              noOptionsText="Sem Opções"
              isOptionEqualToValue={(option, value) =>
                option && value && option.id === value.id
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  label="Produto*"
                  error={Boolean(formik.errors.statusDeal)}
                  helperText={formik.errors.statusDeal}
                />
              )}
            />
          </FormControl>
        </div>

        <div className="col-sm-3 col-md-3 col-lg-3">
          <button
            className="buton-white-black-border btn btn-block btn-lg"
            style={{ marginTop: "10px" }}
            disabled={!novoProdutoSelecionado}
            onClick={() => setAbrirDetProduto(true)}
          >
            VISUALIZAR PRODUTO
          </button>
        </div>
        <div className="col-sm-3 col-md-3 col-lg-3">
          <button
            onClick={() => fnCadastrarProduto()}
            className="buton-green btn btn-block btn-lg"
            disabled={!novoProdutoSelecionado}
            style={{ marginTop: "10px" }}
          >
            ADICIONAR PRODUTO
          </button>
        </div>
      </div>
      <div>
        {id && formik.values.statusDeal != 1 && (
          <div>
            <span>Link da Oportunidade:</span>
            <a
              href={LINK_PORTAL + "/pedido/" + codigo}
              target="_blank"
              className="pl-2"
            >
              {LINK_PORTAL + "/pedido/" + codigo}
            </a>
          </div>
        )}
      </div>
      <div class="row d-flex justify-content-center">
        <div className="col-sm-3 col-md-3 col-lg-3">
          <FormControl>
            <InputLabel id="demo-simple-select-helper-label">
              Pedido Mínimo*
            </InputLabel>
            <Select
              key={formik.values.tipoOportunidade}
              className="select"
              variant="outlined"
              label="Pedido Mínimo*"
              id="tipoOportunidade"
              MenuProps={MenuProps}
              value={formik.values.tipoOportunidade}
              onChange={(e) => {
                formik.setFieldValue("tipoOportunidade", e.target.value);
                setTipoOportunidade(e.target.value);
              }}
              error={Boolean(formik.errors.tipoOportunidade)}
              helperText={formik.errors.tipoOportunidade}
            >
              <MenuItem value="">
                <em>Selecione</em>
              </MenuItem>
              {tipoList.map((item) => (
                <MenuItem key={item.id} value={item.id}>
                  {item.nome}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
        <div className="col-sm-2 col-md-2 col-lg-2">
          <FormControl>
            <TextField
              label=""
              type={
                formik.values.tipoOportunidade === 3 ||
                formik.values.tipoOportunidade === 4 ||
                formik.values.tipoOportunidade === 5
                  ? "number"
                  : "text"
              }
              style={{ minWidth: "150px" }}
              size="small"
              id="pedidoMinimo"
              name="pedidoMinimo"
              variant="outlined"
              disabled={formik.values.tipoOportunidade === 1}
              value={
                formik.values.tipoOportunidade !== 3 &&
                formik.values.tipoOportunidade !== 4 &&
                formik.values.tipoOportunidade !== 5
                  ? formik?.values?.pedidoMinimo?.toLocaleString("pt-br", {
                      style: "currency",
                      currency: "BRL",
                    })
                  : formik.values.pedidoMinimo
              }
              onChange={(e) => {
                const rawValue = e.target.value;
                let parsedValue;

                if (formik.values.tipoOportunidade === 2) {
                  const value = rawValue.replace(/\D/g, "");
                  parsedValue = value ? Number(value) / 100 : 0;
                } else if (
                  formik.values.tipoOportunidade === 3 ||
                  formik.values.tipoOportunidade === 4
                ) {
                  // Apenas inteiros
                  parsedValue = parseInt(rawValue.replace(/\D/g, ""), 10) || 0;
                } else {
                  parsedValue = Number(rawValue);
                }

                formik.setFieldValue(`pedidoMinimo`, parsedValue);
              }}
            />
          </FormControl>
        </div>
      </div>
      {id && (
        <div className="row d-flex justify-content-end">
          <table border="1">
            <thead>
              <tr>
                <th style={{ minWidth: 200, padding: "0 0 0 10px" }}>
                  Descrição
                </th>
                <th style={{ minWidth: 200, padding: "0 0 0 10px" }}>Valor</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ minWidth: 200, padding: "0 0 0 10px" }}>
                  Custo Total (sem ST)
                </td>
                <td style={{ minWidth: 200, padding: "0 0 0 10px" }}>
                  {isNaN(Number(formik.values.custoTotalSemST))
                    ? "-"
                    : Number(formik.values.custoTotalSemST).toLocaleString(
                        "pt-br",
                        { style: "currency", currency: "BRL" }
                      )}
                </td>
              </tr>
              <tr>
                <td style={{ minWidth: 200, padding: "0 0 0 10px" }}>
                  Substituição Tributária
                </td>
                <td style={{ minWidth: 200, padding: "0 0 0 10px" }}>
                  {isNaN(Number(formik.values.substituicaoTributario))
                    ? "-"
                    : Number(
                        formik.values.substituicaoTributario
                      ).toLocaleString("pt-br", {
                        style: "currency",
                        currency: "BRL",
                      })}
                </td>
              </tr>
              <tr>
                <td style={{ minWidth: 200, padding: "0 0 0 10px" }}>
                  Fee de Greeners
                </td>
                <td style={{ minWidth: 200, padding: "0 0 0 10px" }}>
                  {isNaN(Number(formik.values.feeGreenersTotal))
                    ? "-"
                    : Number(formik.values.feeGreenersTotal).toLocaleString(
                        "pt-br",
                        { style: "currency", currency: "BRL" }
                      )}
                </td>
              </tr>
              <tr>
                <td style={{ minWidth: 200, padding: "0 0 0 10px" }}>
                  Fee Operador Logístico
                </td>
                <td style={{ minWidth: 200, padding: "0 0 0 10px" }}>
                  {isNaN(Number(formik.values.feeOperLogTotal))
                    ? "-"
                    : Number(formik.values.feeOperLogTotal).toLocaleString(
                        "pt-br",
                        { style: "currency", currency: "BRL" }
                      )}
                </td>
              </tr>
              <tr>
                <td style={{ minWidth: 200, padding: "0 0 0 10px" }}>
                  Custo Total (R$)
                </td>
                <td style={{ minWidth: 200, padding: "0 0 0 10px" }}>
                  {isNaN(Number(formik.values.custoTotal))
                    ? "-"
                    : Number(formik.values.custoTotal).toLocaleString("pt-br", {
                        style: "currency",
                        currency: "BRL",
                      })}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
      {id && (
        <div className="row d-flex justify-content-center">
          <div className="col-md-4">
            <button
              onClick={gerarRelatorioConciliacao}
              className="buton-green btn btn-block btn-lg"
              style={{ marginTop: "10px" }}
            >
              GERAR RELATÓRIO DE CONCILIAÇÃO
            </button>
          </div>
          <div className="col-sm-4 col-md-4 col-lg-4">
            <button
              onClick={gerarPedidoPdf}
              className="buton-green btn btn-block btn-lg"
              style={{ marginTop: "10px" }}
            >
              GERAR PEDIDO EM PDF
            </button>
          </div>
        </div>
      )}
      {abrirDetProduto && (
        <Modal
          className="modal-sizeOp"
          open={abrirDetProduto}
          close={handleCloseModal}
        >
          <div
            className={"modal-contentOp defaultFont"}
            style={{ width: "90%", height: "90vh" }}
          >
            <div className="d-flex justify-content-start w-100 ">
              <div className="titulo">Produto: Detalhe</div>
            </div>

            <>
              <div className="row mt10 ml5">
                <Typography variant="body" style={{ fontWeight: 800 }}>
                  Dados Cadastrais
                </Typography>
              </div>

              <div className="row w-100">
                {/* GTIN */}
                <div className="col-md-2">
                  <FormControl>
                    <TextField
                      disabled
                      label="GTIN/EAN (Código de Barras) *"
                      type="text"
                      size="small"
                      id={novoDetalheProdutoSelecionado.gtin}
                      InputLabelProps={{
                        shrink:
                          !!novoDetalheProdutoSelecionado.gtin || "sem gtin",
                      }}
                      name={novoDetalheProdutoSelecionado.gtin}
                      className="solid"
                      value={novoDetalheProdutoSelecionado.gtin}
                      variant="outlined"
                    />
                  </FormControl>
                </div>
                {/* SKU */}
                <div className="col-md-2">
                  <FormControl>
                    <TextField
                      disabled
                      label="SKU"
                      type="text"
                      size="small"
                      id={novoDetalheProdutoSelecionado.sku}
                      name={novoDetalheProdutoSelecionado.sku}
                      InputLabelProps={{
                        shrink:
                          !!novoDetalheProdutoSelecionado.sku || "sem SKU",
                      }}
                      variant="outlined"
                      value={novoDetalheProdutoSelecionado.sku || "sem SKU"}
                      onChange={formik.handleChange}
                    />
                  </FormControl>
                </div>
                {/* DESCRICAO */}
                <div className="col-md-8">
                  <FormControl>
                    <TextField
                      disabled
                      label="Descrição"
                      type="text"
                      size="small"
                      id={novoDetalheProdutoSelecionado.nomeProduto}
                      name={novoDetalheProdutoSelecionado.nomeProduto}
                      InputLabelProps={{
                        shrink: !!novoDetalheProdutoSelecionado.nomeProduto,
                      }}
                      variant="outlined"
                      value={novoDetalheProdutoSelecionado.nomeProduto}
                      onChange={formik.handleChange}
                    />
                  </FormControl>
                </div>
              </div>

              <div className="row w-100">
                {/* IMAGEM */}
                <div className="col-md-4">
                  <img
                    alt=""
                    src={novoDetalheProdutoSelecionado.produtoUrlImagem}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = "";
                      e.target.alt = "sem imagem";
                    }}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      borderStyle: "solid",
                    }}
                  />
                </div>
                <div className="col-md-8">
                  <div className="row">
                    {/* Descrição Longa */}
                    <div className="col-md-12">
                      <FormControl>
                        <TextField
                          id={novoDetalheProdutoSelecionado.descricaoProduto}
                          name={novoDetalheProdutoSelecionado.descricaoProduto}
                          variant="outlined"
                          InputLabelProps={{
                            shrink:
                              !!novoDetalheProdutoSelecionado.descricaoProduto,
                          }}
                          type="text"
                          size="small"
                          multiline
                          rows={1}
                          disabled
                          label="Descrição Longa"
                          onChange={formik.handleChange}
                          value={novoDetalheProdutoSelecionado.descricaoProduto}
                        />
                      </FormControl>
                    </div>
                  </div>
                  <div className="row">
                    {/* GPC */}
                    <div className="col-md-6">
                      <FormControl>
                        <TextField
                          disabled
                          label="GPC (Classificação global de produto)"
                          type="text"
                          size="small"
                          variant="outlined"
                          id={novoDetalheProdutoSelecionado.gpc}
                          name={novoDetalheProdutoSelecionado.gpc}
                          InputLabelProps={{
                            shrink: !!novoDetalheProdutoSelecionado.gpc,
                          }}
                          value={novoDetalheProdutoSelecionado.gpc}
                          onChange={formik.handleChange}
                        />
                      </FormControl>
                    </div>
                    {/* CATEGORIA */}
                    <div className="col-md-6">
                      <FormControl>
                        <TextField
                          disabled
                          label="Categoria"
                          type="text"
                          size="small"
                          variant="outlined"
                          value={novoDetalheProdutoSelecionado.categoria}
                          id={novoDetalheProdutoSelecionado.categoria}
                          name={novoDetalheProdutoSelecionado.categoria}
                          InputLabelProps={{
                            shrink: !!novoDetalheProdutoSelecionado.categoria,
                          }}
                          onChange={formik.handleChange}
                        />
                      </FormControl>
                    </div>
                  </div>{" "}
                  <div className="row">
                    {/* NCM */}
                    <div className="col-md-6">
                      <FormControl>
                        <TextField
                          disabled
                          label="NCM (Nomenclatura Comum do Mercado)"
                          type="text"
                          size="small"
                          variant="outlined"
                          id={novoDetalheProdutoSelecionado.ncm}
                          name={novoDetalheProdutoSelecionado.ncm}
                          InputLabelProps={{
                            shrink: !!novoDetalheProdutoSelecionado.ncm,
                          }}
                          value={novoDetalheProdutoSelecionado.ncm}
                          onChange={formik.handleChange}
                        />
                      </FormControl>
                    </div>
                  </div>
                  <div className="row">
                    {/* Descrição NCM */}
                    <div className="col-md-12">
                      <FormControl>
                        <TextField
                          id={novoDetalheProdutoSelecionado.descricaoNcm}
                          name={novoDetalheProdutoSelecionado.descricaoNcm}
                          variant="outlined"
                          InputLabelProps={{
                            shrink:
                              !!novoDetalheProdutoSelecionado.descricaoNcm,
                          }}
                          type="text"
                          size="small"
                          multiline
                          rows={3}
                          disabled
                          label="Descrição NCM"
                          onChange={formik.handleChange}
                          value={novoDetalheProdutoSelecionado.descricaoNcm}
                        />
                      </FormControl>
                    </div>
                  </div>
                </div>
                {/* SELLER */}
                <div className="col-md-4">
                  <FormControl>
                    <TextField
                      disabled
                      label="Seller"
                      type="text"
                      size="small"
                      variant="outlined"
                      id={novoDetalheProdutoSelecionado.seller}
                      name={novoDetalheProdutoSelecionado.seller}
                      InputLabelProps={{
                        shrink: !!novoDetalheProdutoSelecionado.seller,
                      }}
                      value={novoDetalheProdutoSelecionado.seller}
                      onChange={formik.handleChange}
                    />
                  </FormControl>
                </div>
                {/* MARCA */}
                <div className="col-md-4">
                  <FormControl>
                    <TextField
                      disabled
                      label="Marca"
                      type="text"
                      size="small"
                      variant="outlined"
                      value={novoDetalheProdutoSelecionado.marca}
                      id={novoDetalheProdutoSelecionado.marca}
                      name={novoDetalheProdutoSelecionado.marca}
                      InputLabelProps={{
                        shrink: !!novoDetalheProdutoSelecionado.marca,
                      }}
                      onChange={formik.handleChange}
                    />
                  </FormControl>
                </div>
                {/* VALIDADE */}
                <div className="col-md-4">
                  <FormControl>
                    <TextField
                      disabled
                      label="Validade"
                      type="text"
                      size="small"
                      variant="outlined"
                      value={novoDetalheProdutoSelecionado.validade}
                      id={novoDetalheProdutoSelecionado.validade}
                      name={novoDetalheProdutoSelecionado.validade}
                      InputLabelProps={{
                        shrink: !!novoDetalheProdutoSelecionado.validade,
                      }}
                      onChange={formik.handleChange}
                    />
                  </FormControl>
                </div>
                <div className="col-md-12">
                  <Typography variant="body" style={{ fontWeight: 800 }}>
                    Precificação
                  </Typography>
                </div>
                <div className="w-100">
                  <div className="col-md-4">
                    <FormControl>
                      <TextField
                        disabled
                        label="Preço medio varejo"
                        id={novoDetalheProdutoSelecionado.precoMedio}
                        name={novoDetalheProdutoSelecionado.precoMedio}
                        type="text"
                        size="small"
                        variant="outlined"
                        value={novoDetalheProdutoSelecionado.precoMedio}
                        onChange={formik.handleChange}
                        InputLabelProps={{
                          shrink:
                            !!novoDetalheProdutoSelecionado.precoMedio || true,
                        }}
                      />
                    </FormControl>
                  </div>
                </div>
                <div className="col-md-12">
                  <Typography variant="body" style={{ fontWeight: 800 }}>
                    Dados logísticos
                  </Typography>
                </div>
                <div className="col-md-12">
                  <Typography variant="body" style={{ fontWeight: 800 }}>
                    Unidades
                  </Typography>
                </div>
                {/* QUANTIDADE */}
                <div className="col-md-2">
                  <FormControl>
                    <TextField
                      disabled
                      label="Quantidade"
                      id={novoDetalheProdutoSelecionado.quantidadeUnidade}
                      name={novoDetalheProdutoSelecionado.quantidadeUnidade}
                      type="text"
                      size="small"
                      variant="outlined"
                      value={novoDetalheProdutoSelecionado.quantidadeUnidade}
                      onChange={formik.handleChange}
                      InputLabelProps={{
                        shrink:
                          !!novoDetalheProdutoSelecionado.quantidadeUnidade ||
                          true,
                      }}
                    />
                  </FormControl>
                </div>
                {/* ALTURA */}
                <div className="col-md-2">
                  <FormControl>
                    <TextField
                      disabled
                      label="Altura"
                      id={novoDetalheProdutoSelecionado.alturaUnidade}
                      name={novoDetalheProdutoSelecionado.alturaUnidade}
                      type="text"
                      size="small"
                      variant="outlined"
                      value={novoDetalheProdutoSelecionado.alturaUnidade}
                      onChange={formik.handleChange}
                      InputLabelProps={{
                        shrink:
                          !!novoDetalheProdutoSelecionado.alturaUnidade || true,
                      }}
                    />
                  </FormControl>
                </div>
                {/* LARGURA */}
                <div className="col-md-2">
                  <FormControl>
                    <TextField
                      disabled
                      label="Largura"
                      id={novoDetalheProdutoSelecionado.larguraUnidade}
                      name={novoDetalheProdutoSelecionado.larguraUnidade}
                      type="text"
                      size="small"
                      variant="outlined"
                      value={novoDetalheProdutoSelecionado.larguraUnidade}
                      onChange={formik.handleChange}
                      InputLabelProps={{
                        shrink:
                          !!novoDetalheProdutoSelecionado.larguraUnidade ||
                          true,
                      }}
                    />
                  </FormControl>
                </div>
                {/* PROFUNDIDADE */}
                <div className="col-md-2">
                  <FormControl>
                    <TextField
                      disabled
                      label="Profundidade"
                      id={novoDetalheProdutoSelecionado.profundidadeUnidade}
                      name={novoDetalheProdutoSelecionado.profundidadeUnidade}
                      type="text"
                      size="small"
                      variant="outlined"
                      value={novoDetalheProdutoSelecionado.profundidadeUnidade}
                      onChange={formik.handleChange}
                      InputLabelProps={{
                        shrink:
                          !!novoDetalheProdutoSelecionado.profundidadeUnidade ||
                          true,
                      }}
                    />
                  </FormControl>
                </div>
                {/* PESO BRUTO */}
                <div className="col-md-2">
                  <FormControl>
                    <TextField
                      disabled
                      label="Peso bruto"
                      id={novoDetalheProdutoSelecionado.pesoBrutoUnidade}
                      name={novoDetalheProdutoSelecionado.pesoBrutoUnidade}
                      type="text"
                      size="small"
                      variant="outlined"
                      value={novoDetalheProdutoSelecionado.pesoBrutoUnidade}
                      onChange={formik.handleChange}
                      InputLabelProps={{
                        shrink:
                          !!novoDetalheProdutoSelecionado.pesoBrutoUnidade ||
                          true,
                      }}
                    />
                  </FormControl>
                </div>
                {/* PESO LIQUIDO */}
                <div className="col-md-2">
                  <FormControl>
                    <TextField
                      disabled
                      label="Peso liquido"
                      id={novoDetalheProdutoSelecionado.pesoLiquidoUnidade}
                      name={novoDetalheProdutoSelecionado.pesoLiquidoUnidade}
                      type="text"
                      size="small"
                      variant="outlined"
                      value={novoDetalheProdutoSelecionado.pesoLiquidoUnidade}
                      onChange={formik.handleChange}
                      InputLabelProps={{
                        shrink:
                          !!novoDetalheProdutoSelecionado.pesoLiquidoUnidade ||
                          true,
                      }}
                    />
                  </FormControl>
                </div>
                {/* VOLUME */}
                <div className="col-md-2">
                  <FormControl>
                    <TextField
                      disabled
                      label="Volume"
                      id={novoDetalheProdutoSelecionado.volumeUnidade}
                      name={novoDetalheProdutoSelecionado.volumeUnidade}
                      type="text"
                      size="small"
                      variant="outlined"
                      value={novoDetalheProdutoSelecionado.volumeUnidade}
                      onChange={formik.handleChange}
                      InputLabelProps={{
                        shrink:
                          !!novoDetalheProdutoSelecionado.volumeUnidade || true,
                      }}
                    />
                  </FormControl>
                </div>
                <div className="col-md-12">
                  <Typography variant="body" style={{ fontWeight: 800 }}>
                    Caixa
                  </Typography>
                </div>

                {/* GTIN */}
                <div className="col-md-2">
                  <FormControl>
                    <TextField
                      disabled
                      label="GTIN / DUN"
                      id={novoDetalheProdutoSelecionado.gtinDun14Caixa}
                      name={novoDetalheProdutoSelecionado.gtinDun14Caixa}
                      type="text"
                      size="small"
                      variant="outlined"
                      value={
                        novoDetalheProdutoSelecionado.gtinDun14Caixa || true
                      }
                      onChange={formik.handleChange}
                      InputLabelProps={{
                        shrink: !!novoDetalheProdutoSelecionado.gtinDun14Caixa,
                      }}
                    />
                  </FormControl>
                </div>
                {/* UNIDADE POR CAIXA */}
                <div className="col-md-2">
                  <FormControl>
                    <TextField
                      disabled
                      label=" Unidade por caixa"
                      type="text"
                      size="small"
                      id={novoDetalheProdutoSelecionado.quantidadePorCaixa}
                      name={novoDetalheProdutoSelecionado.quantidadePorCaixa}
                      InputLabelProps={{
                        shrink:
                          !!novoDetalheProdutoSelecionado.quantidadePorCaixa ||
                          true,
                      }}
                      variant="outlined"
                      value={novoDetalheProdutoSelecionado.quantidadePorCaixa}
                      onChange={formik.handleChange}
                    />
                  </FormControl>
                </div>
                {/* ALTURA DA CAIXA */}
                <div className="col-md-2">
                  <FormControl>
                    <TextField
                      disabled
                      label="Altura da Caixa"
                      type="text"
                      size="small"
                      id={novoDetalheProdutoSelecionado.alturaCaixa}
                      name={novoDetalheProdutoSelecionado.alturaCaixa}
                      InputLabelProps={{
                        shrink:
                          !!novoDetalheProdutoSelecionado.alturaCaixa || true,
                      }}
                      variant="outlined"
                      value={novoDetalheProdutoSelecionado.alturaCaixa}
                      onChange={formik.handleChange}
                    />
                  </FormControl>
                </div>
                {/* LARGURA DA CAIXA */}
                <div className="col-md-2">
                  <FormControl>
                    <TextField
                      disabled
                      label="Largura da Caixa"
                      type="text"
                      size="small"
                      id={novoDetalheProdutoSelecionado.larguraCaixa}
                      name={novoDetalheProdutoSelecionado.larguraCaixa}
                      InputLabelProps={{
                        shrink: !!novoDetalheProdutoSelecionado.larguraCaixa,
                      }}
                      variant="outlined"
                      value={novoDetalheProdutoSelecionado.larguraCaixa}
                      onChange={formik.handleChange}
                    />
                  </FormControl>
                </div>
                {/* PROFUNDIDADE DA CAIXA */}
                <div className="col-md-2">
                  <FormControl>
                    <TextField
                      disabled
                      label="Profundidade da Caixa"
                      type="text"
                      size="small"
                      id={novoDetalheProdutoSelecionado.profundidadeCaixa}
                      name={novoDetalheProdutoSelecionado.profundidadeCaixa}
                      InputLabelProps={{
                        shrink:
                          !!novoDetalheProdutoSelecionado.profundidadeCaixa,
                      }}
                      variant="outlined"
                      value={novoDetalheProdutoSelecionado.profundidadeCaixa}
                      onChange={formik.handleChange}
                    />
                  </FormControl>
                </div>
                {/* PESO BRUTO DA CAIXA */}
                <div className="col-md-2">
                  <FormControl>
                    <TextField
                      disabled
                      label="Peso Bruto da Caixa"
                      type="text"
                      size="small"
                      id={novoDetalheProdutoSelecionado.pesoBrutoCaixa}
                      name={novoDetalheProdutoSelecionado.pesoBrutoCaixa}
                      InputLabelProps={{
                        shrink: !!novoDetalheProdutoSelecionado.pesoBrutoCaixa,
                      }}
                      variant="outlined"
                      value={novoDetalheProdutoSelecionado.pesoBrutoCaixa}
                      onChange={formik.handleChange}
                    />
                  </FormControl>
                </div>
                {/* PESO LIQUIDO DA CAIXA */}
                <div className="col-md-2">
                  <FormControl>
                    <TextField
                      disabled
                      label="Peso Líquido da Caixa"
                      type="text"
                      size="small"
                      id={novoDetalheProdutoSelecionado.pesoLiquidoCaixa}
                      name={novoDetalheProdutoSelecionado.pesoLiquidoCaixa}
                      InputLabelProps={{
                        shrink:
                          !!novoDetalheProdutoSelecionado.pesoLiquidoCaixa,
                      }}
                      variant="outlined"
                      value={novoDetalheProdutoSelecionado.pesoLiquidoCaixa}
                      onChange={formik.handleChange}
                    />
                  </FormControl>
                </div>
                {/* VOLUME DA CAIXA */}
                <div className="col-md-2">
                  <FormControl>
                    <TextField
                      disabled
                      label="Volume da Caixa"
                      type="text"
                      size="small"
                      id={novoDetalheProdutoSelecionado.volumeCaixa}
                      name={novoDetalheProdutoSelecionado.volumeCaixa}
                      InputLabelProps={{
                        shrink: !!novoDetalheProdutoSelecionado.volumeCaixa,
                      }}
                      variant="outlined"
                      value={novoDetalheProdutoSelecionado.volumeCaixa}
                      onChange={formik.handleChange}
                    />
                  </FormControl>
                </div>

                <div className="col-md-12">
                  <Typography variant="body" style={{ fontWeight: 800 }}>
                    Paletização
                  </Typography>
                </div>
                {/* CAIXA PRO PALLET*/}
                <div className="col-md-2">
                  <FormControl>
                    <TextField
                      disabled
                      label="Caixa por pallet"
                      type="text"
                      size="small"
                      id={
                        novoDetalheProdutoSelecionado.quantidadeDeCaixaPorPallet
                      }
                      name={
                        novoDetalheProdutoSelecionado.quantidadeDeCaixaPorPallet
                      }
                      InputLabelProps={{
                        shrink:
                          !!novoDetalheProdutoSelecionado.quantidadeDeCaixaPorPallet ||
                          true,
                      }}
                      variant="outlined"
                      value={
                        novoDetalheProdutoSelecionado.quantidadeDeCaixaPorPallet
                      }
                      onChange={formik.handleChange}
                    />
                  </FormControl>
                </div>
                {/* ALTURA DO PALLET */}
                <div className="col-md-2">
                  <FormControl>
                    <TextField
                      disabled
                      label="Altura do Pallet"
                      type="text"
                      size="small"
                      id={novoDetalheProdutoSelecionado.alturaPallet}
                      name={novoDetalheProdutoSelecionado.alturaPallet}
                      InputLabelProps={{
                        shrink:
                          !!novoDetalheProdutoSelecionado.alturaPallet || true,
                      }}
                      variant="outlined"
                      value={novoDetalheProdutoSelecionado.alturaPallet}
                      onChange={formik.handleChange}
                    />
                  </FormControl>
                </div>
                {/* LARGURA DO PALLET */}
                <div className="col-md-2">
                  <FormControl>
                    <TextField
                      disabled
                      label="Largura do Pallet"
                      type="text"
                      size="small"
                      id={novoDetalheProdutoSelecionado.larguraPallet}
                      name={novoDetalheProdutoSelecionado.larguraPallet}
                      InputLabelProps={{
                        shrink:
                          !!novoDetalheProdutoSelecionado.larguraPallet || true,
                      }}
                      variant="outlined"
                      value={novoDetalheProdutoSelecionado.larguraPallet}
                      onChange={formik.handleChange}
                    />
                  </FormControl>
                </div>
                {/* PROFUNDIDADE DO PALLET */}
                <div className="col-md-2">
                  <FormControl>
                    <TextField
                      disabled
                      label="Profundidade do Pallet"
                      type="text"
                      size="small"
                      id={novoDetalheProdutoSelecionado.profundidadePallet}
                      name={novoDetalheProdutoSelecionado.profundidadePallet}
                      InputLabelProps={{
                        shrink:
                          !!novoDetalheProdutoSelecionado.profundidadePallet ||
                          true,
                      }}
                      variant="outlined"
                      value={novoDetalheProdutoSelecionado.profundidadePallet}
                      onChange={formik.handleChange}
                    />
                  </FormControl>
                </div>
                {/* PESO BRUTO DO PALLET */}
                <div className="col-md-2">
                  <FormControl>
                    <TextField
                      disabled
                      label="Peso Bruto do Pallet"
                      type="text"
                      size="small"
                      id={novoDetalheProdutoSelecionado.pesoBrutoPallet}
                      name={novoDetalheProdutoSelecionado.pesoBrutoPallet}
                      InputLabelProps={{
                        shrink:
                          !!novoDetalheProdutoSelecionado.pesoBrutoPallet ||
                          true,
                      }}
                      variant="outlined"
                      value={novoDetalheProdutoSelecionado.pesoBrutoPallet}
                      onChange={formik.handleChange}
                    />
                  </FormControl>
                </div>
                {/* PESO LIQUIDO DO PALLET */}
                <div className="col-md-2">
                  <FormControl>
                    <TextField
                      disabled
                      label="Peso L quido do Pallet"
                      type="text"
                      size="small"
                      id={novoDetalheProdutoSelecionado.pesoLiquidoPallet}
                      name={novoDetalheProdutoSelecionado.pesoLiquidoPallet}
                      InputLabelProps={{
                        shrink:
                          !!novoDetalheProdutoSelecionado.pesoLiquidoPallet ||
                          true,
                      }}
                      variant="outlined"
                      value={novoDetalheProdutoSelecionado.pesoLiquidoPallet}
                      onChange={formik.handleChange}
                    />
                  </FormControl>
                </div>
                {/* VOLUME DO PALLET */}
                <div className="col-md-2">
                  <FormControl>
                    <TextField
                      disabled
                      label="Volume do Pallet"
                      type="text"
                      size="small"
                      id={novoDetalheProdutoSelecionado.volumePallet}
                      name={novoDetalheProdutoSelecionado.volumePallet}
                      InputLabelProps={{
                        shrink:
                          !!novoDetalheProdutoSelecionado.volumePallet || true,
                      }}
                      variant="outlined"
                      value={novoDetalheProdutoSelecionado.volumePallet}
                      onChange={formik.handleChange}
                    />
                  </FormControl>
                </div>
              </div>
            </>

            <Button
              style={{ border: "1px solid #000000" }}
              className="buton-white-black-border px-5 py-2"
              onClick={() => setAbrirDetProduto(false)}
            >
              VOLTAR
            </Button>
            {selecionarProduto.aba === "dadosLogisticos" && (
              <>
                <div>
                  <div className="row">
                    <Typography variant="body" style={{ fontWeight: 800 }}>
                      Dados Logisticos
                    </Typography>
                  </div>

                  <div className="row">
                    <div className="col-sm-3 col-md-3 col-lg-3">
                      <FormControl>
                        <TextField
                          label="EAN"
                          type="text"
                          size="small"
                          disabled
                          InputLabelProps={{ shrink: true }}
                          variant="outlined"
                          value={novoDetalheProdutoSelecionado.gtinEan}
                        />
                      </FormControl>
                    </div>
                    <div className="col-sm-9 col-md-9 col-lg-9">
                      <FormControl>
                        <TextField
                          label="Descrição Curta"
                          type="text"
                          size="small"
                          disabled
                          variant="outlined"
                          value={novoDetalheProdutoSelecionado.descricao}
                        />
                      </FormControl>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="row">
                    <Typography variant="body" style={{ fontWeight: 800 }}>
                      Unidade
                    </Typography>
                  </div>

                  <div className="row">
                    <div className="col-sm-3 col-md-3 col-lg-3">
                      <FormControl>
                        <TextField
                          label="Quantidade"
                          type="text"
                          size="small"
                          InputLabelProps={{ shrink: true }}
                          disabled
                          variant="outlined"
                          value={
                            novoDetalheProdutoSelecionado.quantidadeUnidade
                          }
                        />
                      </FormControl>
                    </div>
                    <div className="col-sm-3 col-md-3 col-lg-3">
                      <FormControl>
                        <TextField
                          label="Altura"
                          type="text"
                          size="small"
                          disabled
                          InputLabelProps={{ shrink: true }}
                          variant="outlined"
                          value={novoDetalheProdutoSelecionado.alturaUnidade}
                        />
                      </FormControl>
                    </div>
                    <div className="col-sm-3 col-md-3 col-lg-3">
                      <FormControl>
                        <TextField
                          label="Largura"
                          type="text"
                          size="small"
                          disabled
                          variant="outlined"
                          InputLabelProps={{ shrink: true }}
                          value={novoDetalheProdutoSelecionado.larguraUnidade}
                        />
                      </FormControl>
                    </div>
                    <div className="col-sm-3 col-md-3 col-lg-3">
                      <FormControl>
                        <TextField
                          label="Profundidade"
                          type="text"
                          size="small"
                          disabled
                          variant="outlined"
                          InputLabelProps={{ shrink: true }}
                          value={
                            novoDetalheProdutoSelecionado.profundidadeUnidade
                          }
                        />
                      </FormControl>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-sm-3 col-md-3 col-lg-3">
                      <FormControl>
                        <TextField
                          label="Peso bruto"
                          type="text"
                          size="small"
                          disabled
                          variant="outlined"
                          InputLabelProps={{ shrink: true }}
                          value={novoDetalheProdutoSelecionado.pesoBrutoUnidade}
                        />
                      </FormControl>
                    </div>
                    <div className="col-sm-3 col-md-3 col-lg-3">
                      <FormControl>
                        <TextField
                          label="Peso liquido"
                          type="text"
                          size="small"
                          disabled
                          variant="outlined"
                          InputLabelProps={{ shrink: true }}
                          value={
                            novoDetalheProdutoSelecionado.pesoLiquidoUnidade
                          }
                        />
                      </FormControl>
                    </div>
                    <div className="col-sm-3 col-md-3 col-lg-3">
                      <FormControl>
                        <TextField
                          label="Volume"
                          type="text"
                          size="small"
                          disabled
                          variant="outlined"
                          InputLabelProps={{ shrink: true }}
                          value={novoDetalheProdutoSelecionado.volumeUnidade}
                        />
                      </FormControl>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="row">
                    <Typography variant="body" style={{ fontWeight: 800 }}>
                      Caixa
                    </Typography>
                  </div>

                  <div className="row">
                    <div className="col-sm-3 col-md-3 col-lg-3">
                      <FormControl>
                        <TextField
                          label="GTIN/DUN-14"
                          type="text"
                          size="small"
                          disabled
                          variant="outlined"
                          value={novoDetalheProdutoSelecionado.gtinDun14Caixa}
                        />
                      </FormControl>
                    </div>
                    <div className="col-sm-3 col-md-3 col-lg-3">
                      <FormControl>
                        <TextField
                          label="Quantidade por caixa"
                          type="text"
                          size="small"
                          disabled
                          variant="outlined"
                          value={
                            novoDetalheProdutoSelecionado.quantidadePorCaixa
                          }
                        />
                      </FormControl>
                    </div>
                    <div className="col-sm-3 col-md-3 col-lg-3">
                      <FormControl>
                        <TextField
                          label="Altura da caixa"
                          type="text"
                          size="small"
                          disabled
                          variant="outlined"
                          InputLabelProps={{ shrink: true }}
                          value={novoDetalheProdutoSelecionado.alturaCaixa}
                        />
                      </FormControl>
                    </div>
                    <div className="col-sm-3 col-md-3 col-lg-3">
                      <FormControl>
                        <TextField
                          label="Largura da caixa"
                          type="text"
                          size="small"
                          disabled
                          variant="outlined"
                          InputLabelProps={{ shrink: true }}
                          value={novoDetalheProdutoSelecionado.larguraCaixa}
                        />
                      </FormControl>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-sm-3 col-md-3 col-lg-3">
                      <FormControl>
                        <TextField
                          label="Profundidade de caixa"
                          type="text"
                          size="small"
                          disabled
                          variant="outlined"
                          InputLabelProps={{ shrink: true }}
                          value={
                            novoDetalheProdutoSelecionado.profundidadeCaixa
                          }
                        />
                      </FormControl>
                    </div>
                    <div className="col-sm-3 col-md-3 col-lg-3">
                      <FormControl>
                        <TextField
                          label="Volume da caixa"
                          type="text"
                          size="small"
                          disabled
                          variant="outlined"
                          InputLabelProps={{ shrink: true }}
                          value={novoDetalheProdutoSelecionado.volumeCaixa}
                        />
                      </FormControl>
                    </div>
                    <div className="col-sm-3 col-md-3 col-lg-3">
                      <FormControl>
                        <TextField
                          label="Peso bruto por caixa"
                          type="text"
                          size="small"
                          disabled
                          variant="outlined"
                          InputLabelProps={{ shrink: true }}
                          value={novoDetalheProdutoSelecionado.pesoBrutoCaixa}
                        />
                      </FormControl>
                    </div>
                    <div className="col-sm-3 col-md-3 col-lg-3">
                      <FormControl>
                        <TextField
                          label="Peso líquido por caixa"
                          type="text"
                          size="small"
                          disabled
                          variant="outlined"
                          InputLabelProps={{ shrink: true }}
                          value={novoDetalheProdutoSelecionado.pesoLiquidoCaixa}
                        />
                      </FormControl>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="row">
                    <Typography variant="body" style={{ fontWeight: 800 }}>
                      Paletização
                    </Typography>
                  </div>

                  <div className="row">
                    <div className="col-sm-3 col-md-3 col-lg-3">
                      <FormControl>
                        <TextField
                          label="Qtde. de caixas por pallet"
                          type="text"
                          size="small"
                          disabled
                          variant="outlined"
                          InputLabelProps={{ shrink: true }}
                          value={
                            novoDetalheProdutoSelecionado.quantidadeDeCaixaPorPallet
                          }
                        />
                      </FormControl>
                    </div>
                    <div className="col-sm-3 col-md-3 col-lg-3">
                      <FormControl>
                        <TextField
                          label="Altura do pallet"
                          type="text"
                          size="small"
                          disabled
                          variant="outlined"
                          InputLabelProps={{ shrink: true }}
                          value={novoDetalheProdutoSelecionado.alturaPallet}
                        />
                      </FormControl>
                    </div>
                    <div className="col-sm-3 col-md-3 col-lg-3">
                      <FormControl>
                        <TextField
                          label="Largura do pallet"
                          type="text"
                          size="small"
                          disabled
                          variant="outlined"
                          InputLabelProps={{ shrink: true }}
                          value={novoDetalheProdutoSelecionado.larguraPallet}
                        />
                      </FormControl>
                    </div>
                    <div className="col-sm-3 col-md-3 col-lg-3">
                      <FormControl>
                        <TextField
                          label="Profundidade do pallet"
                          type="text"
                          size="small"
                          disabled
                          variant="outlined"
                          InputLabelProps={{ shrink: true }}
                          value={
                            novoDetalheProdutoSelecionado.profundidadePallet
                          }
                        />
                      </FormControl>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-sm-3 col-md-3 col-lg-3">
                      <FormControl>
                        <TextField
                          label="Peso bruto do pallet"
                          type="text"
                          size="small"
                          disabled
                          variant="outlined"
                          InputLabelProps={{ shrink: true }}
                          value={novoDetalheProdutoSelecionado.pesoBrutoPallet}
                        />
                      </FormControl>
                    </div>
                    <div className="col-sm-3 col-md-3 col-lg-3">
                      <FormControl>
                        <TextField
                          label="Peso liquido do pallet"
                          type="text"
                          size="small"
                          disabled
                          variant="outlined"
                          InputLabelProps={{ shrink: true }}
                          value={
                            novoDetalheProdutoSelecionado.pesoLiquidoPallet
                          }
                        />
                      </FormControl>
                    </div>
                    <div className="col-sm-3 col-md-3 col-lg-3">
                      <FormControl>
                        <TextField
                          label="Volume do pallet"
                          type="text"
                          size="small"
                          disabled
                          variant="outlined"
                          InputLabelProps={{ shrink: true }}
                          value={novoDetalheProdutoSelecionado.volumePallet}
                        />
                      </FormControl>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </Modal>
      )}

      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        className="mt40"
      >
        <div className="col-md-8 buttons">
          <ButtonYesNo
            buttonText="CANCELAR"
            buttonClass="col-md-6 buton-white-black-border"
            alertDescription="Deseja realmente descartar as alterações realizadas?"
            onConfirm={() => history.push("/oportunidade")}
          />

          <div className="ml5"></div>
          <button
            type="submit"
            className="col-md-6 button-black "
            onClick={() => {
              if (!formik.values.tipoOportunidade || formik.values.tipoOportunidade === "" || formik.values.tipoOportunidade === null) {
                addSnackBar({
                  message: "Por favor selecione um pedido mínimo.",
                  info: "warning",
                  open: true,
                  autoHideDuration: 3000,
                });

                setTimeout(() => {
                  const closeButton = document.querySelector(
                    ".MuiButtonBase-root.MuiButton-root.MuiButton-text"
                  );
                  if (closeButton) {
                    closeButton.click();
                  }
                }, 2000);

                return;
              }
              if (!formik.values.dadosEmpresaSellerId) {
                addSnackBar({
                  message: "Preencha o Seller.",
                  info: "error",
                  open: true,
                  autoHideDuration: 2000,
                });

                setTimeout(() => {
                  const closeButton = document.querySelector(
                    ".MuiButtonBase-root.MuiButton-root.MuiButton-text"
                  );
                  if (closeButton) {
                    closeButton.click();
                  }
                }, 2000);

                return;
              }
              id ? fnEditarOportunidade() : fnSalvarOportunidadeNovo();
            }}
          >
            SALVAR
          </button>
        </div>
      </Box>
      {id && (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          className="mt10"
        >
          <div className="col-md-8 flex flex-end buttons ">
            <button
              type="button"
              className="col-md-12 buton-white-black-border "
              onClick={handleDuplicateOpportunity}
            >
              DUPLICAR OPORTUNIDADE
            </button>
          </div>
        </Box>
      )}
    </form>
  );
};

export default EditarOportunidade;
